import React from 'react';
import { LoadableTypography } from '../../LoadableTypography';


export const TableCellLoadingWrapper: React.FC<{
  loading?: boolean;
  width?: string;
}> = ({
  width = '30px',
  loading = false,
  children,
}) => {
  if (loading) {
    return (
      <LoadableTypography loading width={width} />
    );
  }

  return children as React.ReactElement ?? null;
};
